<template>
  <div class="col-lg-4 col-md-6 ml-auto mr-auto">
    <card class="card-login card-white">
      <div class="mt-2">
        <div v-if="isRedefining">
          <redefine-password-component> </redefine-password-component>
          <b-button
            variant="link"
            class="btn-redefine-by-email"
            @click="setRedefining"
          >
            {{ $t("forgotPassword.redefineByEmail") }}
          </b-button>
        </div>
        <div v-else>
          <forgot-password-component> </forgot-password-component>
          <b-button
            variant="link"
            class="btn-redefine-by-email"
            @click="setRedefining"
          >
            {{ $t("forgotPassword.redefineByPersonalDocument") }}
          </b-button>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
export default {
  name: "ForgotPassword",
  directives: {},
  components: {
    ForgotPasswordComponent: () =>
      import("@/components_rms/System/User/ForgotPasswordComponent.vue"),
    RedefinePasswordComponent: () =>
      import("@/components_rms/System/User/RedefinePasswordComponent.vue"),
  },
  data() {
    return {
      isRedefining: true,
    };
  },
  methods: {
    openModal() {
      this.$refs.openModal.show();
    },
    setRedefining() {
      this.isRedefining = !this.isRedefining;
    },
  },
};
</script>
<style scoped>
.btn-redefine-by-email {
  font-size: 10px;
}

.right {
  text-align: right;
  width: 100%;
}
.forgetPassword {
  margin-top: -15px !important;
  margin-left: -20px;
  text-align: left !important;
}
</style>
